<template lang="">
  <div class="faq-section">
    <h3 class="">{{ no }}</h3>
    <main class="">
      <h3 style="cursor: pointer" @click="triggerButton()">{{ title }}</h3>

      <p v-if="modal" class="">
        {{ subTitle }}
      </p>
    </main>
    <img
      v-if="modal"
      src="../../assets/img/pajamas_dash.svg"
      @click="triggerButton()"
      style="cursor: pointer"
    />
    <img
      v-else="!modal"
      src="../../assets/img/Add.svg"
      @click="triggerButton()"
      style="cursor: pointer"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    no: String,
    subTitle: String,
    autoOpen: String,
  },
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    triggerButton() {
      this.modal = !this.modal;
    },
  },
};
</script>
